import type { Milestone } from "@shopify-harness/sdk";

/**
 * スタブモード（VITE_API_MODE=stub）で使う運用マイルストーンのフィクスチャ。
 * 実運用では管理画面か MCP の create_milestone で D1 に登録したデータが表示される。
 */
export const milestonesFixture: Milestone[] = [
  {
    id: "milestone-1",
    shopDomain: "analytical-engine.myshopify.com",
    startedOn: "2026-07-02",
    endedOn: null,
    category: "llmo",
    title: "LLMO向けの構造化データ整備を実施した",
    description: "主要50商品に Product / FAQ の JSON-LD を追加。AI検索経由の流入変化を観測する。",
    createdAt: "2026-07-02T09:00:00.000Z",
    updatedAt: "2026-07-02T09:00:00.000Z"
  },
  {
    id: "milestone-2",
    shopDomain: "analytical-engine.myshopify.com",
    startedOn: "2026-07-10",
    endedOn: "2026-07-20",
    category: "campaign",
    title: "夏物セール（20%オフ）を実施した",
    description: null,
    createdAt: "2026-07-10T01:00:00.000Z",
    updatedAt: "2026-07-10T01:00:00.000Z"
  },
  {
    id: "milestone-3",
    shopDomain: "analytical-engine.myshopify.com",
    startedOn: "2026-07-18",
    endedOn: null,
    category: "crm",
    title: "カゴ落ちシナリオの配信条件を緩和した",
    description:
      "対象を「24時間以内の離脱」から「72時間以内」に拡大。配信数と転換率の変化を確認する。",
    createdAt: "2026-07-18T05:30:00.000Z",
    updatedAt: "2026-07-18T05:30:00.000Z"
  }
];
